<template>
  <div class="event-item" data-t="event-item">
    <div class="left">
      <div class="names">
        <StSkeletonLoader width="113px" height="16px" :shimmer-opacity="0.28" />
        <StSkeletonLoader width="113px" height="16px" :shimmer-opacity="0.28" />
      </div>
      <div class="bottom-left">
        <StSkeletonLoader width="140px" height="8px" :shimmer-opacity="0.28" />
      </div>
    </div>
    <div class="right">
      <div class="lines-wrapper">
        <StSkeletonLoader
          v-for="i in 3"
          :key="i"
          height="24px"
          :shimmer-opacity="0.28"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.event-item {
  display: flex;
  gap: var(--spacing-150);

  height: 97px;
  padding: 0 var(--spacing-500) 0 var(--spacing-100);

  border-bottom: 1px solid rgb(255 255 255 / 8%);
}

.names {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-050);
}

.event-item-markets {
  display: flex;
  justify-content: space-between;
}

.left {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  gap: var(--spacing-150);

  min-width: 0;
  padding-block: var(--spacing-150);
}

.bottom-left {
  display: flex;
  justify-content: flex-start;
}

.right {
  display: flex;
  flex-shrink: 0;
  gap: var(--spacing-200);
  align-items: flex-start;

  padding: var(--spacing-150) 0;
}

.lines-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--spacing-400);
  width: 556px;
}
</style>
